import { useApolloClient, useLazyQuery } from "@apollo/client";

import { DOCUMENT, DOCUMENT_TYPES, DOCUMENTS } from "@graphql";

export const useDocument = () => {
  const apolloClient = useApolloClient();

  const [fetchDocument, { loading, error }] = useLazyQuery(DOCUMENT, {
    fetchPolicy: "network-only",
  });

  const getDocument = async (documentId: string) => {
    const result = await fetchDocument({
      variables: { input: { documentId } },
    });

    await apolloClient.refetchQueries({ include: [DOCUMENT_TYPES, DOCUMENTS] });

    return result.data?.document;
  };

  return { getDocument, loading, error };
};
